// extracted by mini-css-extract-plugin
export default {"title":"addCollaborator_title__xUJac"};